import React from "react";
import Image from "next/future/image";
import Dots from "../../../public/img/useCases/dots.webp";
import { hostEventUrl } from "../../config/config";

const EngageAudience = ({ title }) => {
  return (
    <>
      <div className={`${title}-root`}>
        <div className={`row`}>
          <div className={`col-lg-6 col-md-12 ${title}-details-root`}>
            <h1 className={`${title}-title`}>
              <span className={`engage `}>Engage & Excite</span>Your audience in
              any kind of events!
            </h1>
            <div className={`pt-4 d-block d-sm-none`}>
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/AudienceUseCases.png"
                alt="Audience use cases"
                width={350}
                height={350}
              />
            </div>
            <div className={`${title}-subText mt-4`}>
              Organizing large events is a challenging task. KonfHub has features and benefits that automate and simplify most of your tasks. Read more to know how!
            </div>
            <div className={`my-5`}>
              <a
                href="https://calendly.com/tanvi-konfhub/konfhub-quizhub-walk-through"
                target="_blank"
                rel="noreferrer"
              >
                <button
                  className={`btn btn-header mb-lg-2 mb-xxl-2 me-2 me-sm-0 btn-demo schedule-demo`}
                >
                  <span>Schedule Demo</span>&nbsp;
                  <i className={`fas fa-chevron-circle-right arrow`}></i>
                </button>
              </a>
              <a
                href={`${hostEventUrl}/create/event`}
                target="_blank"
                rel="noreferrer"
              >
                <button
                  className={`btn btn-header mb-lg-2 ms-0 ms-lg-5 ms-sm-3 mt-sm-0 mt-3 schedule-demo`}
                >
                  <span>Host an Event</span>&nbsp;
                  <i className={`fas fa-chevron-circle-right arrow`}></i>
                </button>
              </a>
            </div>
          </div>
          <div className={`col-lg-6 col-md-12 d-none d-sm-block`}>
            <div className={`py-2`}>
              <div
                className={`${title}-image py-2 d-flex justify-content-start`}
              >
                <Image
                  className={`${title}-RootImageDesktop`}
                  src="/img/useCases/AudienceUseCases.png"
                  alt="Audience use cases"
                  width={660}
                  height={551}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={`dots-1`}></div>
        <div className={`dots-2`}></div>
      </div>
      <style jsx>
        {`
          .${title}-root {
            background: #f6f9fc;
            padding: 50px 0px;
            padding-left: 105px;
            padding-right: 105px;
          }
          .${title}-root .${title}-details-root {
            padding-right: 50px;
            margin-top: 40px;
          }
          .${title}-root .${title}-details-root .${title}-title {
            font-family: "Poppins";
            font-weight: 600;
            font-size: 41px;
            line-height: 53px;
            color: #572148;
          }
          .${title}-root .${title}-details-root .${title}-title .engage {
            color: #fb5850;
            margin-right: 8px;
          }
          .${title}-root .${title}-details-root .${title}-subText {
            font-family: "Nunito";
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
            color: #525252;
            padding-right: 40px;
          }
          .${title}-root .dots-1 {
            background: url(${Dots}) no-repeat;
            width: 130px;
            height: 96px;
            position: absolute;
            top: 130px;
            left: 85px;
            background-size: cover;
          }
          .${title}-root .dots-2 {
            background: url(${Dots}) no-repeat;
            width: 130px;
            height: 96px;
            position: absolute;
            top: 230px;
            left: 550px;
            background-size: cover;
          }
          .${title}-root .${title}-RootImageDesktop {
            max-width: 100%;
            margin-top: -50px;
          }
          .${title}-root .${title}-image {
            width: auto;
            margin-top: -50px;
          }
          @media screen and (max-width: 722px) {
            .${title}-root {
              padding-left: 50px;
              padding-right: 50px;
            }
            .${title}-root .${title}-RootImageDesktop {
              position: relative;
              top: 0px;
              right: 215px;
              max-width: 80%;
            }
          }
          @media screen and (max-width: 679px) {
            .${title}-root {
              padding-left: 30px;
              padding-right: 30px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 0px;
            }
            .${title}-root .${title}-RootImageDesktop {
              position: relative;
              top: 50px;
              right: 15px;
              max-width: 80% !important;
            }
            .${title}-root .dots-2 {
              position: absolute;
              top: 140px;
              left: 349px;
            }
          }
          @media screen and (max-width: 480px) {
            .${title}-root {
              padding-left: 20px;
              padding-right: 20px;
              padding-bottom: 0px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 0px;
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .${title}-root .${title}-details-root .${title}-title {
              font-weight: 600;
              font-size: 30px;
              line-height: 45px;
            }
            .${title}-root .${title}-details-root .${title}-subText {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              padding-right: 0px;
            }
            .schedule-demo {
              width: 100% !important;
              display: inline-flex;
              justify-content: space-between;
              align-items: center;
            }
            .${title}-root .dots-1 {
              background: url(${Dots}) no-repeat;
              width: 130px;
              height: 96px;
              position: absolute;
              top: 115px;
              left: 10px;
              background-size: cover;
            }
            .${title}-root .dots-2 {
              background: url(${Dots}) no-repeat;
              width: 130px;
              height: 96px;
              position: absolute;
              top: 200px;
              left: 285px;
              background-size: cover;
            }
          }
          @media screen and (max-width: 400px) {
            .${title}-root .dots-2 {
              background: url(${Dots}) no-repeat;
              width: 130px;
              height: 96px;
              position: absolute;
              top: 190px;
              left: 235px;
              background-size: cover;
            }
          }
        `}
      </style>
    </>
  );
};

export default EngageAudience;
